<template>
  <div class="title-page-view">
    <div class="title-content">
      <h2>{{titleObj.mainHeading}}</h2>
      <h3>{{titleObj.subhead}}</h3>
      <div><p></p></div>
      <p class="title">{{titleObj.content}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {}
    },
    props:{
      titleObj:Object
    },
    methods:{},
    mounted(){}
  }
</script>
<style lang="scss" rel="stylesheet" scoped="">
  .title-page-view{
    padding-top:50px;
    .title-content{
      h2{
        color:#333333;
        font-size:34px;
      }
      h3{
        color:#333333;
        font-size:30px;
      }
      div{
        width:190px;
        height:1px;
        background:#d5d5d5;
        margin:10px auto;
        p{
          width:50px;
          height: 2px;
          background:#ffbd1f;
          margin:auto;
          position: relative;
          top:-1px;
        }
      }
      .title{
        color:#555555;
        font-size:16px;
      }
    }
  }
</style>
